<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="495px"
    :close-on-click-modal="false"
    @close="$router.replace('/todos')"
  >
    <el-form
      ref="todoForm"
      v-loading="loading"
      :model="todo"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="title"
        label="Cím"
      >
        <el-input
          v-model="todo.title"
        />
      </el-form-item>
      <el-form-item
        prop="description"
        label="Leírás"
      >
        <el-input
          v-model="todo.description"
          type="textarea"
          :rows="5"
          style="word-break: normal;"
        />
      </el-form-item>
      <el-form-item
        prop="description"
        label="Státusz"
      >
        <el-radio-group v-model="todo.status">
          <el-radio
            label="todo"
            border
          >
            Elintézendő
          </el-radio>
          <el-radio
            label="in-progress"
            border
          >
            Folyamatban
          </el-radio>
          <el-radio
            label="done"
            border
          >
            Kész
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        prop="deadline"
        label="Határidő"
      >
        <el-date-picker
          v-model="todo.deadline"
          type="datetime"
          style="width: 100%;"
          :clearable="false"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :picker-options="{ firstDayOfWeek: 1 }"
        />
      </el-form-item>
      <el-form-item
        prop="responsible_users"
        label="Felelős"
      >
        <el-select
          v-model="todo.responsible_users"
          style="width: 100%;"
          filterable
          multiple
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="`${user.last_name} ${user.first_name} (@${user.username})`"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="subscribers"
        label="Feliratkozók"
      >
        <el-select
          v-model="todo.subscribers"
          style="width: 100%;"
          filterable
          multiple
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="`${user.last_name} ${user.first_name} (@${user.username})`"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
      <el-switch
        v-if="type === 'add'"
        v-model="todo.is_recurring"
        active-text="Ismétlődő todo"
        style="margin-bottom: 20px;"
      />
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            v-if="todo.is_recurring"
            prop="interval"
            label="Ismétlődés intervallum"
          >
            <el-input
              v-model="todo.interval"
              class="input-with-select"
            >
              <el-select
                slot="append"
                v-model="todo.interval_type"
                style="width: 100px"
              >
                <el-option
                  label="hetente"
                  value="week"
                />
                <el-option
                  label="havonta"
                  value="month"
                />
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            v-if="todo.is_recurring && todo.interval_type === 'month'"
            prop="day_of_month"
            label="Hányadikán jöjjön létre a todo?"
          >
            <el-select
              v-model="todo.day_of_month"
              style="width: 100%;"
            >
              <el-option
                v-for="day in days"
                :key="day + 1"
                :label="`${day + 1}.`"
                :value="day + 1"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="todo.is_recurring && todo.interval_type === 'week'"
            prop="day_of_week"
            label="Melyik napon jöjjön létre a todo?"
          >
            <el-select
              v-model="todo.day_of_week"
              style="width: 100%;"
            >
              <el-option
                label="Hétfő"
                :value="1"
              />
              <el-option
                label="Kedd"
                :value="2"
              />
              <el-option
                label="Szerda"
                :value="3"
              />
              <el-option
                label="Csütörtök"
                :value="4"
              />
              <el-option
                label="Péntek"
                :value="5"
              />
              <el-option
                label="Szombat"
                :value="6"
              />
              <el-option
                label="Vasárnap"
                :value="7"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        v-if="todo.is_recurring"
        prop="recurring_deadline"
        label="Létrehozástól számított határidő"
      >
        <el-input
          v-model="todo.recurring_deadline"
          class="input-with-select"
        >
          <el-select
            slot="append"
            v-model="todo.recurring_deadline_type"
            style="width: 150px"
          >
            <el-option
              label="nap"
              value="day"
            />
            <el-option
              label="hét"
              value="week"
            />
            <el-option
              label="hónap"
              value="month"
            />
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="todo.is_recurring"
        prop="expiration"
        label="Ismétlődés érvényessége"
      >
        <el-date-picker
          v-model="todo.expiration"
          type="daterange"
          format="yyyy. MM. dd."
          value-format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
          style="width: 100%;"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/todos')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'todoId'],
  data() {
    return {
      days: [...Array(28).keys()],
      loading: false,
      buttonLoading: false,
      todo: {
        is_recurring: false,
        status: 'todo',
        subscribers: [],
        interval: 1,
        interval_type: 'month',
        recurring_deadline: 2,
        recurring_deadline_type: 'day',
        day_of_week: 1,
        day_of_month: 1,
        expiration: null,
        responsible_users: []
      },
      rules: {
        title: [
          {
            required: true,
            message: 'Cím megadása kötelező',
            trigger: 'change'
          }
        ],
        deadline: [
          {
            required: true,
            message: 'Határidő megadása kötelező',
            trigger: 'change'
          }
        ],
        responsible_users: [
          {
            required: true,
            message: 'Felelős megadása kötelező',
            trigger: 'change'
          }
        ]
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új todo';
      } else if (this.type === 'update') {
        return 'Todo módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    if (!this.users.length) {
      await this.$store.dispatch('user/fetchAll');
    }
    if (this.todoId) {
      this.todo = await this.$store.dispatch('todo/fetch', this.todoId);
      this.todo.subscribers = this.todo.subscribers.map(s => s.id);
      this.todo.responsible_users = [this.todo.responsible_user_id]
    }
    this.loading = false;
  },
  methods: {
    async store() {
      this.$refs['todoForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('todo/create', this.todo);
            } else if (this.type === 'update') {
              await this.$store.dispatch('todo/update', this.todo);
            }
            this.$store.dispatch('todo/fetchAll');
            this.buttonLoading = false;
            this.$router.replace('/todos');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    }
  },
};
</script>
